import { Link } from "@tanstack/react-router";
import { Mail, Phone, MapPin, Linkedin, Twitter, Instagram, Facebook } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-8 bg-ink text-background">
      <div className="container-page pt-4 pb-4 grid gap-18 lg:grid-cols-3 items-start">
        <div className="max-w-sm">
          <img src="/logo.png" alt="BigBrand Booster Logo" className="h-40 w-auto brightness-0 invert -mt-8" />
          <p className="mt-0 text-sm leading-relaxed text-background/70">
            A global digital marketing agency engineering performance at the intersection of media, content, technology and creativity.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-background/60">Explore</h4>
          <ul className="mt-4 space-y-2 gap-4 grid grid-cols-2 text-sm">
            {[
              ["About", "/about"], ["Services", "/services"], // ["Portfolio", "/portfolio"], // Temporarily disabled
              ["Careers", "/careers"], ["Blogs", "/blogs"], ["Contact", "/contact"],
            ].map(([l, h]) => (
              <li key={h}><Link to={h} className="text-background/80 hover:text-primary-glow">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-background/60">Get in touch</h4>
          <ul className="mt-5 space-y-3 text-sm text-background/80">
            <li className="flex items-start gap-3"><Phone className="h-4 w-4 mt-1 text-primary-glow" /> +91 8810201567</li>
            <li className="flex items-start gap-3"><Mail className="h-4 w-4 mt-1 text-primary-glow" /> info@BigBrandBooster.com</li>
            <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-1 text-primary-glow" /> Sec 82 Gurgaon</li>
          </ul>
          <div className="mt-8 flex gap-12">
            {[Linkedin, Twitter, Instagram, Facebook].map((Icon, i) => {
              const href = Icon === Linkedin 
                ? "https://www.linkedin.com/in/bigbrandbooster-digital-marketing-agency-12a486411" 
                : "#";
              return (
                <a key={i} href={href} className="inline-flex h-6 w-30 items-center justify-center rounded-full border border-background/15 transition hover:bg-primary hover:border-primary">
                  <Icon className="h-6 w-12" />
                </a>
              );
            })}
          </div>
        </div>
      </div>
      <div className="border-t border-background/10">
        <div className="container-page py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-background/60">
          <p>© {new Date().getFullYear()} BigBrandBooster Digital. All rights reserved.</p>
          <p>Crafted with intent — performance, brand & growth.</p>
        </div>
      </div>
    </footer>
  );
}
